<script>
import i18n from '@/i18n'
import { Form } from '@/views/reports/components'
import { navigationPrevent } from '@/mixins'
import { createDashboard } from '@/views/reports/api'
import { success, danger } from '@/lib/notification'
export default {
    mixins: [navigationPrevent],
    navigationOptions: {
        allowNavigation: true,
        title: i18n.t('reports.dashboards.leaveDashboard'),
        message: i18n.t('reports.dashboards.leavingDashboardWithoutSave'),
    },
    components: {
        CForm: Form,
    },
    render(h) {
        return h('c-form', {
            on: { submit: this.onSubmit, isChanged: this.onChangeForm },
        })
    },
    methods: {
        onChangeForm() {
            this.setAllowNavigation(false)
        },
        onSubmit(data) {
            const loader = this.createLoader()
            createDashboard(data)
                .then(dashboard => {
                    this.showSucessToast()
                    this.setAllowNavigation(true)
                    this.goToDashboardView(dashboard.id)
                })
                .catch(() => this.showErrorToast())
                .finally(() => loader.hide())
        },
        createLoader() {
            return this.$loading.show({
                width: 60,
                height: 60,
                color: '#022b4f',
            })
        },
        showSucessToast() {
            success(
                this.$t('notification.createdSuccessfully', {
                    item: 'Dashboard',
                })
            )
        },
        showErrorToast() {
            danger()
        },
        goToDashboardView(dashboardId) {
            this.$router.push(`/v2/reports/view/${dashboardId}`)
        },
    },
}
</script>
